export default {
    name: "All Purchase Dashboard",
    path: "/purchase/exp-dash",
    meta: {
        icon: "dashboard",
        auth: true
    },
    departmentName: "Dashboard",
    finalPagePermision: "",

    component: require("../component/dashboard/purchaseDashboardDetail.vue")
};


// WEBPACK FOOTER //
// ./src/sidebar/purchaseDashboard.js